import React, { useState } from 'react';
import './AboutUs.css';
import FAQ from '../../components/FAQ/FAQ';
import aboutAppImage from '../../assets/images/aboutUs.png';
import image1 from '../../assets/images/advisoryImages/m-hiromi.png';  
import image2 from '../../assets/images/advisoryImages/miya-K.png';
import image3 from '../../assets/images/advisoryImages/deepak.png';
import image4 from '../../assets/images/advisoryImages/pranab.png';
import saurabhImage from '../../assets/images/managementTeam/saurabh.png';
import sameerImage from '../../assets/images/managementTeam/sameer.png';
import bhavikImage from '../../assets/images/managementTeam/bhavik.png';
import durgeshImage from '../../assets/images/managementTeam/durgesh.png';
import subrotoImage from '../../assets/images/managementTeam/subroto.png';
import diwakarImage from '../../assets/images/managementTeam/diwakar_updated.png';
import facebook from '../../assets/icons/facebook-aboutUs.svg';
import linkedin from '../../assets/icons/linkedin-aboutUS.svg';
import twitter from '../../assets/icons/x-logo-aboutUs.svg';

const AboutUs = () => {
  const [selectedMember, setSelectedMember] = useState(null);

  const openModal = (member, section) => {
    setSelectedMember({ ...member, section });
  };

  const closeModal = () => {
    setSelectedMember(null);
  };

  const teamMembers = [
    {
      id: 1,
      name: 'Ms. Hiromi Okuda',
      role: 'Strategic Advisor & Mentor',
      description: 'She received her Master\'s degree in Social Welfare from University of Bombay. She specializes in IT Conferences and Startup events in Japan and abroad. Established Wiz. Group Inc. in 2001 and started organizing major IT Conferences in Japan. She has also written books for Social Welfare and Self Improvements Published on Nikkei Business Publications, Sogo Horei Publishing Co., Ltd and PHP Publications',
      image: image1, // Placeholder - replace with actual image
      social: {
        facebook: '#',
        instagram: '#',
        linkedin: '#',
        twitter: '#'
      }
    },
    {
      id: 2,
      name: 'Ms. Miya Kajiyama',
      role: 'Investor & Mentor',
      roleSubtext: '(CEO Uotaro Group, Japan)',
      description: 'Miss Miya Kajiyama is a prominent businesswoman in the seafood industry and the owner of Uotaro, a leading seafood retail and restaurant company in central Japan. Founded in 1995, Uotaro has earned a strong reputation for delivering the freshest seafood and maintaining high-quality standards. Based in Aichi Prefecture, the company continues to thrive under Miss Kajiyama’s leadership, contributing significantly to the local economy and culinary culture.',
      image: image2, // Placeholder - replace with actual image
      social: {
        facebook: '#',
        instagram: '#',
        linkedin: '#',
        twitter: '#'
      }
    },
    {
      id: 3,
      name: 'Deepak Seth',
      role: 'Advisor & Consultant',
      description: 'Deepak is an IT professional with over 25 years of diverse industry experience in the US. He has held pivotal roles ranging from Architecture, Program and Product Management, showcasing expertise across the spectrum of IT functions in renowned companies such as Allstate and GoDaddy. Fueled by a passion for entrepreneurship and mentoring, Deepak leverages his rich background to drive innovative solutions and contribute to the growth and success of dynamic ventures.',
      image: image3, // Placeholder - replace with actual image
      social: {
        facebook: '#',
        instagram: '#',
        linkedin: '#',
        twitter: '#'
      }
    },
    {
      id: 4,
      name: 'Pranab Mohanty',
      role: 'Advisor',
      description: 'Pranab is a highly seasoned professional with nearly three decades of expertise in sales and marketing, business development, and general management, with a strong focus on profit and loss (P&L) accountability. He has held influential leadership roles in renowned companies such as Toshiba, Midea, Sonotex Ghana, and Sales India, contributing significantly to the success of the organisations he has been associated with.',
      image: image4, // Placeholder - replace with actual image
      social: {
        facebook: '#',
        instagram: '#',
        linkedin: '#',
        twitter: '#'
      }
    }
  ];

  const managementTeam = [
    {
      id: 1,
      name: 'Saurabh Srivastava',
      role: 'Co-founder and CEO',
      description: 'Saurabh brings over a decade of international experience in industry and consulting, having worked with leading global companies in Tokyo and India on key strategic initiatives. He is a core member of strategy teams for various international clients,known for his pragmatic and straightforward approach to delivering granular strategic solutions. At PhoneVue, Saurabh is responsible for ensuring compliance, strategizing marketing efforts, and establishing and overseeing e-commerce operations.',
      image: saurabhImage,
      social: {
        facebook: '#',
        instagram: '#',
        linkedin: '#',
        twitter: '#'
      }
    },
    {
      id: 2,
      name: 'Sameer Chowdhery',
      role: 'Co-founder & Director',
      description: 'Sameer has been based in Japan for 22 years and has worked with startup ecosystems across Japan, India, UAE, Singapore, and France for over a decade. With a strong IT background and a passion for future innovations, he has mentored startups in fundraising, scaling, and market expansion. At PhoneVue, he leads international business expansion and manages smartphone exports to Dubai, Singapore, Africa, and the USA.',
      image: sameerImage,
      social: {
        facebook: '#',
        instagram: '#',
        linkedin: '#',
        twitter: '#'
      }
    },
    {
      id: 3,
      name: 'Bhavik Kumar',
      role: 'Co-founder & GM',
      description: 'Bhavik possesses extensive expertise in managing end-to-end logistics operations, smartphone procurement, Android and iOS application development, and executing result-driven digital marketing strategies. With years of hands-on experience and a strong understanding of evolving market trends, he plays a key role in driving operational efficiency, product innovation, and business growth.',
      image: bhavikImage,
      social: {
        facebook: 'https://www.facebook.com/share/1AMrYMfzSy/?mibextid=wwXIfr',
        instagram: '#',
        linkedin: 'https://www.linkedin.com/in/bhavik-kumar-ab84718?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app',
        twitter: 'https://x.com/bhavik_24?s=11&t=PzOLHGFYmKs5tC4jM1RBDQ'
      }
    },
    {
      id: 4,
      name: 'Diwakar Kumar',
      role: 'Head of IT',
      description: 'Diwakar brings over 14 years of experience in building high-impact mobile and digital solutions for businesses ranging from ambitious startups to established enterprises, specializing in transforming product ideas into scalable, performance-driven mobile applications that deliver measurable business value. With deep expertise across Android, iOS, and backend systems, he has successfully led the end-to-end delivery of complex applications—including real-time tracking platforms, CRM solutions, location-based services, and fintech products—while maintaining a strong balance of technical excellence, user-centric design, and long-term scalability.',
      image: diwakarImage,
      social: {
        facebook: '#',
        instagram: '#',
        linkedin: '#',
        twitter: '#'
      }
    },
    {
      id: 5,
      name: 'Subroto Das',
      role: 'Co-founder & CFO',
      description: 'Subroto is a seasoned professional with extensive experience in compliance and accounting solutions for businesses. He oversees PhoneVue’s regulatory filings, licensing, and adherence to industry standards, while also leading financial reporting, budgeting, and forecasting. His strong command of accounting practices and regulations ensures financial accuracy, operational stability, and full compliance.',
      image: subrotoImage,
      social: {
        facebook: '#',
        instagram: '#',
        linkedin: '#',
        twitter: '#'
      }
    }
  ];

  return (
    <div className="about-us-page">
      {/* About Us Section */}
      <section className="about-us-main-section">
        <div className="about-us-main-container">
          <div className="about-us-text-content">
            <div className="about-us-header">
              <div className="about-us-label-wrapper">
                <div className="blue-line"></div>
                <h1 className="about-us-title">About Us</h1>
              </div>
            </div>
            
            <div className="about-us-paragraphs">
              <p className="about-us-paragraph">
                PhoneVue is your premier destination for comprehensive phone diagnostics, powered by our innovative mobile application and backed by trusted repair and reselling services. With a commitment to delivering cutting-edge technology solutions and exceptional customer service, we take pride in offering a seamless experience for all your device needs. Understanding the pivotal role that mobile devices play in our customers' daily lives, our mobile application provides a user-friendly platform for remote diagnostics. Through our app, users can conduct thorough tests to pinpoint any hardware or software issues their devices may encounter.
              </p>
              <p className="about-us-paragraph">
                 Our team of seasoned technicians has meticulously crafted our mobile application to ensure precise and reliable diagnostics, empowering users with actionable insights to make informed decisions about their devices' maintenance or repair requirements.
              </p>
              <p className="about-us-paragraph">
                In addition to our advanced diagnostic capabilities, we specialize in repairing and reselling high-quality refurbished phones and accessories. Our inventory boasts a diverse selection of devices from leading brands, all rigorously inspected and certified to meet our stringent standards of performance and reliability. 
              </p>
              <p className="about-us-paragraph">
                Furthermore, we facilitate the import-export of new branded phones from leading manufacturers, catering to markets in Singapore, UAE, and Japan, thus expanding our global reach and impact.
              </p>
            </div>
          </div>

          <div className="about-us-image-wrapper">
            <img src={aboutAppImage} alt="PhoneVue About App" className="about-app-phone-image" />
          </div>
        </div>
      </section>

      {/* Our Team / Advisory Board Section */}
      <section className="advisory-board-section">
        <div className="advisory-board-container">
          <div className="advisory-board-header">
            <p className="team-label">Our Team</p>
            <h2 className="advisory-board-title">Advisory Board</h2>
            <p className="advisory-board-description">
              Guided by experienced industry leaders who bring strategic insight, global exposure, and long-term vision.
            </p>
          </div>

          <div className="team-grid">
            {teamMembers.map((member) => (
              <div key={member.id} className="team-card">
                <div className="team-card-image-wrapper">
                  <img src={member.image} alt={member.name} className="team-card-image" />
                </div>
                <h3 className="team-card-name">{member.name}</h3>
                <p className="team-card-role">
                  {member.role}
                  {member.roleSubtext && <span className="team-card-role-subtext"> {member.roleSubtext}</span>}
                </p>
                <p 
                  className="team-card-description"
                  onClick={() => openModal(member, 'advisory')}
                  style={{ cursor: 'pointer' }}
                >
                  {member.description}
                </p>
                {/* <div className="team-card-social">
                  <a href={member.social.facebook} target="_blank" rel="noopener noreferrer" className="social-link">
                    <img src={facebook} alt="Facebook" />
                  </a>
                  <span className="social-divider"></span>
                  <a href={member.social.linkedin} target="_blank" rel="noopener noreferrer" className="social-link">
                    <img src={linkedin} alt="LinkedIn" />
                  </a>
                  <span className="social-divider"></span>
                  <a href={member.social.twitter} target="_blank" rel="noopener noreferrer" className="social-link">
                    <img src={twitter} alt="Twitter" />
                  </a>
                </div> */}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Management Team Section */}
      <section className="management-team-section">
        <div className="management-team-container">
          <div className="management-team-header">
            <h2 className="management-team-title">Management Team</h2>
            <p className="management-team-description">
              Guided by experienced industry leaders who bring strategic insight, global exposure, and long-term vision.
            </p>
          </div>

          <div className="management-team-grid">
            {managementTeam.map((member) => (
              <div key={member.id} className="team-card">
                <div className="team-card-image-wrapper">
                  <img src={member.image} alt={member.name} className="team-card-image" />
                </div>
                <h3 className="team-card-name">{member.name}</h3>
                <p className="team-card-role">
                  {member.role}
                  {member.roleSubtext && <span className="team-card-role-subtext"> {member.roleSubtext}</span>}
                </p>
                <p 
                  className="team-card-description"
                  onClick={() => openModal(member, 'management')}
                  style={{ cursor: 'pointer' }}
                >
                  {member.description}
                </p>
                {/* <div className="team-card-social">
                  <a href={member.social.facebook} target="_blank" rel="noopener noreferrer" className="social-link">
                    <img src={facebook} alt="Facebook" />
                  </a>
                  <span className="social-divider"></span>
                  <a href={member.social.linkedin} target="_blank" rel="noopener noreferrer" className="social-link">
                    <img src={linkedin} alt="LinkedIn" />
                  </a>
                  <span className="social-divider"></span>
                  <a href={member.social.twitter} target="_blank" rel="noopener noreferrer" className="social-link">
                    <img src={twitter} alt="Twitter" />
                  </a>
                </div> */}
              </div>
            ))}
          </div>
        </div>
      </section>
      <section>
        <FAQ />
      </section>

      {/* Member Detail Modal */}
      {selectedMember && (
        <div className="member-modal-overlay" onClick={closeModal}>
          <div className="member-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="member-modal-close" onClick={closeModal} aria-label="Close">
              <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 6L6 18M6 6L18 18" stroke="#212121" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
            <div className="member-modal-image-wrapper">
              <div className="member-modal-image-container">
                <img src={selectedMember.image} alt={selectedMember.name} className="member-modal-image" />
                <div className="member-modal-blue-arc"></div>
              </div>
            </div>
            <h3 className="member-modal-name">{selectedMember.name}</h3>
            <p className="member-modal-role">
              {selectedMember.role}
              {selectedMember.roleSubtext && <span className="member-modal-role-subtext"> {selectedMember.roleSubtext}</span>}
            </p>
            <p className="member-modal-description">{selectedMember.description}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default AboutUs;
